import { render, staticRenderFns } from "./FeedbackMessage.vue?vue&type=template&id=4090bc7e&scoped=true&"
import script from "./FeedbackMessage.vue?vue&type=script&lang=js&"
export * from "./FeedbackMessage.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackMessage.vue?vue&type=style&index=0&id=4090bc7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4090bc7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VLayout})
